<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">平台资质详情</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.store.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.store.name }} </el-form-item>
        <el-form-item label="业务:"> {{ basicInfo.store.salesman.fullName }} </el-form-item>
        <el-form-item label="企业名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="纳税人识别号:"> {{ basicInfo.taxno }} </el-form-item>
        <el-form-item label="注册地址:"> {{ basicInfo.addressline }} </el-form-item>
        <el-form-item label="注册电话:"> {{ basicInfo.phone }} </el-form-item>
        <el-form-item label="开户银行:"> {{ basicInfo.bankName }} </el-form-item>
        <el-form-item label="开户账户:"> {{ basicInfo.bankAccount }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button" v-show="operationType === 'audit'">
      <el-button round style="width: 100px" @click="checkType = false, checkDialog = true">审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="checkType = true, checkDialog = true">审核通过</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType ? '是否确认审核通过？' : '是否确认审核拒绝？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { certificationAudit } from '@/api/finance'

export default {
  name: 'check-certification',
  data () {
    return {
      loading: false,

      operationType: '',
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
      },
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.basicInfo = this.$route.query.row
    this.basicInfo.phone = this.$msg.filterBridal(this.$route.query.row.phone)
    this.operationType = this.$route.query.operationType
  },
  methods: {
    check () {
      let auditVo = {
        action: this.checkType ? 'audit' : 'reject',
        storeCertId: this.basicInfo.storeCertId
      }
      this.loading = true
      certificationAudit(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.checkDialog = false
          this.$router.go(-1)
          // if (this.checkType) {
          //   this.checkTrueDialog = true
          // } else {
          //   this.checkDialog = false
          //   this.$router.go(-1)
          // }
        }
      }).finally(res => {
        let timer = setTimeout(() => {
          this.loading = false
          clearTimeout(timer)
        }, 500)
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";
</style>
